var VOCABULARY_PREFIX = 'VOCABULARY_';
/**
 * MARC tag patterns in the registry use `#` as a single-character wildcard
 * (`41#`, `4##`, `55#`). Length must match — a pattern is always three
 * characters, like a tag.
 */
export var tagMatchesPattern = function (tag, pattern) {
    if (!pattern || pattern.length !== tag.length)
        return false;
    for (var i = 0; i < pattern.length; i += 1) {
        if (pattern[i] !== '#' && pattern[i] !== tag[i])
            return false;
    }
    return true;
};
/** The `VOCABULARY_*` code a subfield declares inline, if any. */
export var declaredVocabularyType = function (subfield) {
    var _a;
    if (subfield.vocabularyType)
        return subfield.vocabularyType;
    if ((_a = subfield.recordType) === null || _a === void 0 ? void 0 : _a.startsWith(VOCABULARY_PREFIX))
        return subfield.recordType;
    return undefined;
};
export var resolveVocabularyBinding = function (subfield, fieldTag, vocabularyTypes) {
    var _a, _b, _c, _d;
    var declared = declaredVocabularyType(subfield);
    if (declared) {
        var info = vocabularyTypes.find(function (t) { return t.code === declared; });
        return {
            vocabularyType: declared,
            validationType: (_a = info === null || info === void 0 ? void 0 : info.validationType) !== null && _a !== void 0 ? _a : null,
            source: 'subfield',
        };
    }
    for (var _i = 0, vocabularyTypes_1 = vocabularyTypes; _i < vocabularyTypes_1.length; _i++) {
        var type = vocabularyTypes_1[_i];
        var hit = ((_b = type.bindings) !== null && _b !== void 0 ? _b : []).find(function (binding) { return binding.subfieldCode === subfield.code
            && tagMatchesPattern(fieldTag, binding.tagPattern); });
        if (hit) {
            return {
                vocabularyType: type.code,
                // Per-binding, not per-type: the API carries `validationType` on the
                // binding and a type can in principle bind at different strictness.
                validationType: (_d = (_c = hit.validationType) !== null && _c !== void 0 ? _c : type.validationType) !== null && _d !== void 0 ? _d : null,
                source: 'binding',
            };
        }
    }
    return null;
};
